import { render, staticRenderFns } from "./o_smena.vue?vue&type=template&id=c35b4e24&"
import script from "./o_smena.vue?vue&type=script&lang=js&"
export * from "./o_smena.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports